import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "sonner";
import SEO from "@/components/SEO";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import { Events, Branding } from "@/components/OffersSection";
import HowItWorks from "@/components/HowItWorks";
import Features from "@/components/Features";
import Occasions from "@/components/Occasions";
import Gallery from "@/components/Gallery";
import AiImageNote from "@/components/AiImageNote";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import "@/App.css";

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-white font-body antialiased">
        <SEO />
        <Navbar />
        <main>
          <Hero />
          <Events />
          <Branding />
          <HowItWorks />
          <Features />
          <Occasions />
          <Gallery />
          <AiImageNote />
          <Pricing />
          <FAQ />
          <ContactForm />
        </main>
        <Footer />
        <Toaster
          position="top-right"
          richColors
          closeButton
          toastOptions={{
            classNames: {
              toast: "font-body",
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
